"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailsList = void 0;
const react_1 = __importDefault(require("react"));
const DetailsList_module_css_1 = __importDefault(require("./DetailsList.module.css"));
const classnames_1 = __importDefault(require("classnames"));
const Icon_1 = require("../Icon");
const DetailsList = ({ items }) => {
    return (react_1.default.createElement("ul", { className: DetailsList_module_css_1.default.list }, items.map((item, index) => {
        var _a;
        return (react_1.default.createElement("li", { key: (_a = item.key) !== null && _a !== void 0 ? _a : index, className: DetailsList_module_css_1.default.item },
            react_1.default.createElement("div", { className: classnames_1.default(DetailsList_module_css_1.default.content) },
                react_1.default.createElement(Icon_1.Icon, { icon: item.icon, size: "md", variant: "primary" })),
            react_1.default.createElement("div", { className: classnames_1.default(DetailsList_module_css_1.default.content) },
                react_1.default.createElement("div", null, item.content),
                react_1.default.createElement("div", null, item.sub))));
    })));
};
exports.DetailsList = DetailsList;
//# sourceMappingURL=DetailsList.js.map